import { render, staticRenderFns } from "./eadPerfilAluno.vue?vue&type=template&id=057ae9d1&scoped=true"
import script from "./eadPerfilAluno.vue?vue&type=script&lang=js"
export * from "./eadPerfilAluno.vue?vue&type=script&lang=js"
import style0 from "./eadPerfilAluno.vue?vue&type=style&index=0&id=057ae9d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057ae9d1",
  null
  
)

export default component.exports